"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var gutter = 8;
var elPrimary = '#FFF',
    elFocus = '#3399FF',
    elDivider = '#b8b8b8';
var tLabel = '#646464',
    tError = '#f34235',
    tAccent = '#5b9b21',
    tPrimary = '#363636';
var tsSmall = '14px',
    tsNormal = '16px';
var tlSmall = '22px';
var _default = {
  palette: {
    fontFamily: 'Arial'
  },
  phone: {
    idleBackground: elPrimary,
    focusBackground: elPrimary,
    hoverBackground: elPrimary,
    errorBackground: elPrimary,
    paddingLeft: "".concat(gutter, "px"),
    paddingRight: "".concat(gutter, "px"),
    paddingTop: '0',
    paddingBottom: '0',
    idleBorderStyle: 'solid',
    hoverBorderStyle: 'solid',
    focusBorderStyle: 'solid',
    errorBorderStyle: 'solid',
    idleBorderWidth: '1px',
    hoverBorderWidth: '1px',
    focusBorderWidth: '1px',
    errorBorderWidth: '1px',
    idleBorderColor: elDivider,
    hoverBorderColor: elDivider,
    focusBorderColor: elFocus,
    errorBorderColor: tError,
    idleBorderRadius: '3px',
    hoverBorderRadius: '3px',
    focusBorderRadius: '3px',
    errorBorderRadius: '3px',
    labelColor: tLabel,
    labelFontSize: tsSmall,
    idleLabelColor: tLabel,
    hoverLabelColor: tLabel,
    focusLabelColor: tLabel,
    disabledLabelColor: tLabel,
    errorLabelColor: tLabel,
    labelLineHeight: tlSmall
  },
  button: {
    borderRadius: '3px',
    paddingTop: "".concat(gutter, "px"),
    paddingRight: "".concat(gutter * 4, "px"),
    paddingBottom: "".concat(gutter, "px"),
    paddingLeft: "".concat(gutter * 4, "px"),
    primary: {
      borderRadius: '3px',
      paddingTop: "".concat(gutter, "px"),
      paddingRight: "".concat(gutter * 4, "px"),
      paddingBottom: "".concat(gutter, "px"),
      paddingLeft: "".concat(gutter * 4, "px")
    }
  },
  plainText: {
    labelColor: tLabel,
    labelFontSize: tsSmall,
    color: tPrimary,
    fontSize: tsNormal,
    lineHeight: 1.5
  },
  input: {
    borderColor: elDivider,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '3px',
    background: elPrimary,
    color: tPrimary,
    boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    outline: 'none',
    paddingTop: "".concat(gutter, "px"),
    paddingRight: "".concat(gutter, "px"),
    paddingBottom: "".concat(gutter, "px"),
    paddingLeft: "".concat(gutter, "px"),
    fontSize: tsNormal,
    label: {
      fontSize: tsNormal,
      color: tLabel,
      lineHeight: tlSmall,
      hover: {
        color: tLabel
      },
      error: {
        color: tLabel
      },
      disabled: {
        color: tLabel
      },
      focus: {
        color: tLabel
      }
    },
    underscore: {},
    hover: {
      borderColor: elDivider,
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '3px',
      background: elPrimary,
      color: tPrimary,
      boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
      outline: 'none'
    },
    focus: {
      borderColor: elFocus,
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '3px',
      background: elPrimary,
      color: tPrimary,
      boxShadow: "0, 0, 1px, 1px, ".concat(elFocus),
      outline: 'none'
    },
    error: {
      borderColor: tError,
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '3px',
      background: elPrimary,
      color: tError,
      boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
      outline: 'none'
    },
    disabled: {
      borderColor: elDivider,
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '3px',
      background: elPrimary,
      color: tPrimary,
      boxShadow: "none",
      outline: 'none'
    }
  },
  separatedInput: {
    labelFontSize: tsSmall,
    labelLineHeight: tlSmall,
    idleBoxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    focusBoxShadow: "0, 0, 1px, 1px, ".concat(elFocus),
    hoverBoxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    errorBoxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    disabledBoxShadow: "none",
    idleOutline: 'none',
    focusOutline: 'none',
    hoverOutline: 'none',
    errorOutline: 'none',
    disabledOutline: 'none',
    idleBorderStyle: 'solid',
    hoverBorderStyle: 'solid',
    focusBorderStyle: 'solid',
    errorBorderStyle: 'solid',
    disabledBorderStyle: 'dotted',
    idleBorderRadius: '3px',
    hoverBorderRadius: '3px',
    focusBorderRadius: '3px',
    errorBorderRadius: '3px',
    disabledBorderRadius: '3px',
    idleBorderWidth: '1px',
    hoverBorderWidth: '1px',
    focusBorderWidth: '1px',
    errorBorderWidth: '1px',
    disabledBorderWidth: '1px',
    idleBorderColor: elDivider,
    hoverBorderColor: elDivider,
    focusBorderColor: elFocus,
    errorBorderColor: tError,
    disabledBorderColor: elDivider,
    idleBackground: elPrimary,
    hoverBackground: elPrimary,
    focusBackground: elPrimary,
    errorBackground: elPrimary,
    disabledBackground: elPrimary,
    labelColor: tLabel,
    idleLabelColor: tLabel,
    hoverLabelColor: tLabel,
    focusLabelColor: tLabel,
    disabledLabelColor: tLabel,
    errorLabelColor: tLabel
  },
  dropDown: {
    labelFontSize: tsNormal,
    idleBoxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    focusBoxShadow: "0, 0, 1px, 1px, ".concat(elFocus),
    hoverBoxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    errorBoxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.05) inset",
    disabledBoxShadow: "none",
    idleOutline: 'none',
    focusOutline: 'none',
    hoverOutline: 'none',
    errorOutline: 'none',
    disabledOutline: 'none',
    idleBorderStyle: 'solid',
    hoverBorderStyle: 'solid',
    focusBorderStyle: 'solid',
    errorBorderStyle: 'solid',
    disabledBorderStyle: 'dotted',
    idleBorderRadius: '3px',
    hoverBorderRadius: '3px',
    focusBorderRadius: '3px',
    errorBorderRadius: '3px',
    disabledBorderRadius: '3px',
    idleBorderWidth: '1px',
    hoverBorderWidth: '1px',
    focusBorderWidth: '1px',
    errorBorderWidth: '1px',
    disabledBorderWidth: '1px',
    idleBorderColor: elDivider,
    hoverBorderColor: elDivider,
    focusBorderColor: elFocus,
    errorBorderColor: tError,
    disabledBorderColor: elDivider,
    idleBorderBackground: tLabel,
    hoverBorderBackground: tLabel,
    focusBorderBackground: tLabel,
    errorBorderBackground: tLabel,
    disabledBorderBackground: tLabel,
    idleLabelColor: tLabel,
    hoverLabelColor: tLabel,
    focusLabelColor: tLabel,
    errorLabelColor: tLabel,
    disabledLabelColor: tLabel,
    paddingLeft: "".concat(gutter, "px"),
    paddingRight: "".concat(gutter, "px"),
    listBackground: elPrimary,
    background: elPrimary,
    listItemBackground: elPrimary,
    listItemHoverBackground: elPrimary,
    listItemFocusBackground: elPrimary,
    listItemSelectedBackground: elPrimary,
    listItemFocusSelectedBackground: elPrimary,
    listItemHoverSelectedBackground: elPrimary,
    idleBackground: elPrimary,
    focusBackground: elPrimary,
    hoverBackground: elPrimary,
    disabledBackground: elPrimary,
    errorBackground: elPrimary,
    listItemColor: tPrimary,
    listItemHoverColor: tPrimary,
    listItemFocusColor: tPrimary,
    listItemSelectedColor: tPrimary,
    listItemFocusSelectedColor: tPrimary,
    listItemHoverSelectedColor: tPrimary,
    idleColor: tPrimary,
    focusColor: tPrimary,
    hoverColor: tPrimary,
    idlePlaceholder: tPrimary,
    focusPlaceholder: tPrimary,
    hoverPlaceholder: tPrimary,
    disabledPlaceholder: tPrimary,
    disabledColor: tPrimary
  },
  controlHint: {
    color: tLabel,
    linkColor: tAccent
  },
  checkbox: {
    color: tPrimary
  }
};
exports["default"] = _default;